<template>
  <component :is="currentPlayerComponent"></component>
</template>

<script>
import Plyr from './player.vue';
import Video from './player2.vue';
import UserApi from "@/api/user/UserApi";

export default {
  data() {
    return {
      playerOption: null,
    };
  },
  computed: {
    currentPlayerComponent() {
      return this.playerOption === 1 ? Video : Plyr;
    }
  },
  created() {
    this.loadPlayerOption();
  },
  methods: {
    async loadPlayerOption() {

      try {
        const response = await UserApi.playeroptionApi();
        if (response.status === 1) {
          this.playerOption = response.data;
          return this.playerOption;
        } else {
          console.error('Error:', response.message);
          return null;
        }
      } catch (error) {
        console.error("error!", error);
        return null;
      }
    }
  }
};
</script>
